<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / Master Files / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div>
        <button
          class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0"
          @click="$refs.createCurrency.show()"
          v-if="role_modules.some(item => item.value == 'currency.create')"
        >
          <i class="uil-plus mr-1"></i> {{ $t('currency.action.create_record') }}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
      <Table
        ref="list"
        :useView="role_modules.some(item => item.value == 'currency.view')"
        :useEdit="role_modules.some(item => item.value == 'currency.edit')"
        noTitle
        :params="params"
        :fields="fields"
        :action="role_modules.some(item => item.value == 'currency') ? action : false"
        @openFormBar="openFormBar"
      />
      </div>
    </div>
    <Dialog
      centered
      title="View Currency"
      ref="viewCurrency"
      size="md"
      :component="viewComponent"
      :parameters="{ currencyID, submitted }"
      v-if="role_modules.some(item => item.value == 'currency.view')"
    />
    <Dialog
      customBtnClass="component-master-files"
      centered
      autoload
      is_reset_model
      title="Create Currency"
      ref="createCurrency"
      size="md"
      yesText="Create"
      noText="Cancel"
      :buttonDisable="created"
      :component="createComponent"
      @onYes="onCreateCurrency"
      v-if="role_modules.some(item => item.value == 'currency.create')"
    />
    <Dialog
      customBtnClass="component-master-files"
      centered
      autoload
      title="Update Currency"
      ref="editCurrency"
      size="md"
      yesText="Update"
      noText="Cancel"
      :component="editComponent"
      :buttonDisable="updated"
      :parameters="{ currencyID, submitted }"
      @onYes="onUpdateCurrency"
      v-if="role_modules.some(item => item.value == 'currency.edit')"
    />
  </div>
</template>

<script>
import Table from '@components/table'
import moment from 'moment/moment'
import Dialog from '@components/offcanvas'
import CreateComponent from './components/dialogs/create.vue'
import EditComponent from './components/dialogs/edit.vue'
import ViewComponent from './components/dialogs/view.vue'

import error from '@utils/error'

export default {
  components: {
    Table,
    Dialog
  },
  computed: {
    createComponent() {
      return CreateComponent
    },
    editComponent() {
      return EditComponent
    },
    viewComponent() {
      return ViewComponent
    }
  },
  data () {
    return {
      fields: [
        {
          label: this.$t('currency.table.symbol'),
          key:'symbol' 
        },
        {
          label: this.$t('currency.table.code'), 
          key:'code' 
        },
        { 
          label: this.$t('currency.table.name'),
          key:'name',
          sortable: true
        },
        { 
          label: this.$t('currency.table.date_created'), 
          key:'date_created', 
          formatter: (val) => moment(val).format('YYYY-MM-DD')
        },
        {
          key:'actions',
          label:''
        }
      ],
      params: {},
      action: 'currency/pagination',
      currencyID: '',
      submitted: false,
      created: false,
      updated: false,
    }
  },
  methods: {
    openFormBar(id, editMode = false) {
      this.currencyID = id
      if(!editMode){
        this.$refs.viewCurrency.show()
      }else{
        this.$refs.editCurrency.show()
      }
    },
    onUpdateCurrency(val) {
      this.updated = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.id = model._id ? model._id : model.id ? model.id : ''

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.updated = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('currency/update', model)
      .then(res => {
        if (res && res.data) {
          this.submitted = !this.submitted;
          this.$refs.list.fetchData();
          this.$refs.editCurrency.hide();
          this.$bvToast.toast(`Currency successfully updated!`, {
            title: "Notification",
            variant: 'success'
          })
          setTimeout(() => {
            this.updated = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.updated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onCreateCurrency(val) {
      this.created = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('currency/create', model)
      .then(res => {
        if (res && res.data) {
          this.submitted = !this.submitted;
          this.$refs.list.fetchData();
          this.$refs.createCurrency.hide();
          this.$bvToast.toast(`Currency successfully created!`, {
            title: "Notification",
            variant: 'success'
          });
          setTimeout(() => {
            this.created = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
  }
}
</script>